import React from "react";
import "./style.css";


function Footer() {
  return (
    <footer className="portfolioFooter" style={{marginTop: "50px"}}>
      <h6>© 2021 Copyright</h6>
    </footer>
  );
}
export default Footer